import { ILogin, ITrocaLogin } from "shared/interfaces/signInInterfaces";
import { api } from "./axios/api";

// Login próprio do MOF novo (plano de 07/10/2026, Etapa B): nenhuma chamada de login vai à API antiga.
// O token devolvido é o mesmo formato do legado — as telas que usam apiAntigo continuam aceitando-o.

export async function signIn(login: ILogin) {
  return api.post("Autenticacao/Login", login).then((res) => res.data);
}

export async function signInChange(trocaLogin: ITrocaLogin) {
  return api
    .post("Autenticacao/TrocarUsuario", { idUsuario: trocaLogin.idUsuario })
    .then((res) => res.data);
}

/** Hidratação da sessão (guard de rotas): relê o usuário no banco e re-emite o token. */
export async function renovarSessao() {
  return api.get("Autenticacao/MinhaSessao").then((res) => res.data);
}

export async function listarUsuariosTroca(): Promise<{ value: number; label: string }[]> {
  return api.get("Autenticacao/UsuariosTroca").then((res) => res.data);
}

export async function solicitarNovaSenha(email: string): Promise<string> {
  return api.post("Autenticacao/SolicitarNovaSenha", { email }).then((res) => res.data);
}

export async function obterDadosNovaSenha(idPublico: string): Promise<{ nome: string; email: string }> {
  return api
    .get(`Autenticacao/DadosNovaSenha/${encodeURIComponent(idPublico)}`)
    .then((res) => res.data);
}

export async function definirSenha(idPublico: string, senha: string): Promise<string> {
  return api.post("Autenticacao/DefinirSenha", { idPublico, senha }).then((res) => res.data);
}

export interface IMinhaConta {
  nome: string;
  email: string;
  empresa: string;
  tipo: string;
}

export async function obterMinhaConta(): Promise<IMinhaConta> {
  return api.get("Autenticacao/MinhaConta").then((res) => res.data);
}

export async function alterarSenha(senhaAtual: string, novaSenha: string): Promise<string> {
  return api.post("Autenticacao/AlterarSenha", { senhaAtual, novaSenha }).then((res) => res.data);
}

/** Mensagem do servidor ({ errors: { Mensagens: [...] } }) ou a padrão. O interceptor rejeita com a resposta. */
export function mensagemDeErro(erro: any, padrao: string): string {
  const mensagens = erro?.data?.errors?.Mensagens;
  if (Array.isArray(mensagens) && mensagens.length > 0) return mensagens.join("\n");
  if (typeof mensagens === "string" && mensagens) return mensagens;
  return padrao;
}
